import { createAsyncThunk } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { notify } from 'components/Common/Toast';

interface Invoice {
    amount: number;
    subject?: string;
    username: string;
    currencyCode: string;
}

export const sendInvoice = createAsyncThunk('invoice/sendInvoice', async (payload: Invoice) => {
    const response: any = await client.post('/request/requestMoney', payload);
    if (response?.code === 200) {
        notify('Invoice sent successfully', 'success');
    }
    return response;
});
